const APP_ACTIONS = {
  //check organization
  CHECK_ORGANIZATION_REQUEST: "CHECK_ORGANIZATION_REQUEST",
  CHECK_ORGANIZATION_REQUEST_SUCCESS: "CHECK_ORGANIZATION_REQUEST_SUCCESS",
  CHECK_ORGANIZATION_REQUEST_FAIL: "CHECK_ORGANIZATION_REQUEST_FAIL",
};
export default APP_ACTIONS;
